import React from 'react';
import PropTypes from 'prop-types';
import AdminPricingSettingsContainer from './AdminPricingSettingsContainer';
import PriceBookTableContainer from '../pricing/PriceBookTableContainer';
import IndexAndViewer from '../shared/IndexAndViewer';

export default class SuperadminPricing extends React.Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    activeLink: PropTypes.number,
    dialog: PropTypes.object.isRequired,
    handleAccountSelect: PropTypes.func.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    priceBookList: PropTypes.object.isRequired,
    updatePriceAction: PropTypes.func.isRequired,
    getPriceBookAction: PropTypes.func.isRequired,
    selectedAccount: PropTypes.object,
    toggleDialog: PropTypes.func.isRequired,
  };

  static defaultProps = {
    activeLink: null,
    selectedAccount: undefined,
  };

  state = { platform: 'CRM' };

  handlePlatformChange = evt => {
    this.setState({ platform: evt.target.value });
  };

  renderPriceBook = account => {
    const {
      dialog,
      isSuperAdmin,
      priceBookList,
      getPriceBookAction,
      updatePriceAction,
      toggleDialog,
    } = this.props;
    const priceBook = priceBookList.get(account.id);
    const { platform } = this.state;
    const isCRM = platform === 'CRM';
    const platformList = isCRM ? 'crmList' : 'maList';

    if (priceBook !== undefined) {
      return (
        <div>
          <span className="pull-right">
            <label htmlFor="platformSelect">
              Select A Platform:{' '}
              <select id="platformSelect" value={platform} onChange={this.handlePlatformChange}>
                <option value="CRM">CRM</option>
                <option value="MA">MA</option>
              </select>
            </label>
          </span>
          <h3>{account.companyName}</h3>
          <br />
          <div className="price-preview-table">
            <AdminPricingSettingsContainer accountId={account.id} />
            <div className="card card-block">
              <PriceBookTableContainer
                accountId={account.id}
                dialog={dialog}
                isSuperAdmin={isSuperAdmin}
                isCRM={isCRM}
                tableContents={priceBook.get(platformList)}
                revShare={priceBook.get('revShare')}
                updatePriceAction={updatePriceAction}
                openDialogFunction={toggleDialog}
                closeDialogFunction={toggleDialog}
                getPriceBookAction={getPriceBookAction}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="no-reports version text-muted">
        <p>Price Book is undefined</p>
      </div>
    );
  };

  render() {
    const { accounts, activeLink, handleAccountSelect, selectedAccount } = this.props;

    const content = this.renderPriceBook(selectedAccount);

    return (
      <div className="container extra-wide-table">
        <IndexAndViewer
          activeLink={activeLink}
          content={content}
          list={accounts}
          handleSelect={handleAccountSelect}
          title="Price Books:"
        />
      </div>
    );
  }
}
